<div class="organisation-container">
  <app-menu [organisation]="organisation" [screen]="screen" (menuEvent)="handleFunctionEvent($event)"></app-menu>
  @if (loading) {
    <spinner-overlay [overlay]=true></spinner-overlay>
  }

  <mat-card appearance="raised" class="page-header">
    <h2>Statistics and billing</h2>
    <p class="page-description">Usage of LINQ by {{organisation?.name || 'this organisation'}}, what it costs and the billing records.</p>
    @if (organisation && organisation.isExemptFromPayment) {
      <div class="exempt-banner" role="status">
        <mat-icon>info</mat-icon>
        <span>This organisation is exempt from usage payments. Invoices are not generated, so the costs below are for information only.</span>
      </div>
    }
  </mat-card>

  <div class="card-grid">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Usage</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-insight-cards [cards]="cards"></app-insight-cards>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Billing records</mat-card-title>
      </mat-card-header>
      @if (billingRecords) {
        <mat-card-content>
          @if (hasCharges()) {
            <app-bar-chart [data]="billingChartData" indexAxis="x" [sort]="false" [isStacked]="true" [height]="300" [stacks]="['Nodes', 'Projects', 'Users']"></app-bar-chart>
          }@else {
            <p class="note empty-chart">No charges so far. Usage has stayed within the free allowance.</p>
          }
          <div class="table-scroll">
            <app-billing-records-table [billingRecords]="billingRecords"></app-billing-records-table>
          </div>
        </mat-card-content>
      }
    </mat-card>

    <!-- costs and the stacked charts share a row half and half, at the same height -->
    <div class="split-row">
      <mat-card appearance="raised">
        <mat-card-header>
          <mat-card-title>Costs</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <h3>Current monthly cost</h3>
          @if (currentRecord) {
            <p>Based on current usage the monthly cost is <b>{{currency.symbol}}{{currentRecord.amount | number}} {{currency.code}}</b>.</p>
          }
          <app-insight-cards [cards]="costCards"></app-insight-cards>
  
          @if (nextMonthRecord) {
            <h3>Projected cost at end of month</h3>
            <p class="note">An estimate of the next monthly bill based on usage and the current trend, assuming no change to projects or users. Change the numbers to see the effect on the cost.</p>
            <div class="projection">
              <div class="projection-inputs">
                <mat-form-field>
                  <mat-label>Nodes</mat-label>
                  <input matInput class="number-input" [(ngModel)]="nextMonthRecord.nodes.number" type="number" min="0" (ngModelChange)="handleProjectedChange()">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Projects</mat-label>
                  <input matInput class="number-input" [(ngModel)]="nextMonthRecord.projects.number" type="number" min="0" (ngModelChange)="handleProjectedChange()">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Users</mat-label>
                  <input matInput class="number-input" [(ngModel)]="nextMonthRecord.users.number" type="number" min="0" (ngModelChange)="handleProjectedChange()">
                </mat-form-field>
              </div>
              <div class="projection-result" data-testid="projected-cost">
                <div class="breakdown">
                  <span>Nodes</span><span>{{currency.symbol}}{{nextMonthRecord.nodes.amount | number}}</span>
                  <span>Projects</span><span>{{currency.symbol}}{{nextMonthRecord.projects.amount | number}}</span>
                  <span>Users</span><span>{{currency.symbol}}{{nextMonthRecord.users.amount | number}}</span>
                  <span class="total">Projected bill</span><span class="total">{{currency.symbol}}{{nextMonthRecord.amount | number}} {{currency.code}}</span>
                </div>
                <button mat-stroked-button color="accent" (click)="refreshProjection()" matTooltip="Put the numbers back to the projection from current usage and trend">
                  <mat-icon>restart_alt</mat-icon>Reset projection
                </button>
              </div>
            </div>
          }
  
          @if (organisation) {
            <div class="settings-heading">
              <h3>Billing settings</h3>
              <button mat-stroked-button color="accent" (click)="editOrganisation()"><mat-icon>edit</mat-icon>Edit settings</button>
            </div>
            <dl class="settings-list">
              <div>
                <dt>Billing currency</dt>
                <dd>{{currency.code}}</dd>
              </div>
              <div>
                <dt>Billing email</dt>
                <dd>{{organisation.billingEmail || 'Not set'}}</dd>
              </div>
              <div>
                <dt>Invoice reference</dt>
                <dd>{{organisation.invoiceReference || 'Not set'}}</dd>
              </div>
            </dl>
          }
        </mat-card-content>
      </mat-card>
  
      @if (lineData || nodesLineData) {
        <div class="chart-stack">
          @if (lineData) {
            <mat-card appearance="raised">
              <mat-card-header>
                <mat-card-title>Model changes</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <app-line-chart [data]="lineData" [height]="200"></app-line-chart>
              </mat-card-content>
            </mat-card>
          }
          @if (nodesLineData) {
            <mat-card appearance="raised">
              <mat-card-header>
                <mat-card-title>Number of nodes</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <app-line-chart [data]="nodesLineData" [height]="200"></app-line-chart>
              </mat-card-content>
            </mat-card>
          }
        </div>
      }
    </div>
  </div>
</div>
